import { Form, Input, Select, Space } from 'antd';
import { map } from 'lodash';
import React from 'react';
import countryCode from '../assets/countryCode.json';

const PhoneNumberInputWithCountyCode = ({
  formItemName = 'countryCode',
  disabled = false,
  ...rest
}) => {
  return (
    <Space.Compact className="width-percent-100">
      <Form.Item name={formItemName} noStyle>
        <Select
          showSearch
          disabled={disabled}
          placeholder="Code"
          className="country-code-input width-percent-20"
          options={[
            ...map(countryCode, (record) => {
              return {
                key: record?.id,
                value: record?.dialCode,
                label: record?.dialCode,
              };
            }),
          ]}
        />
      </Form.Item>
      <Input
        className="country-code-phone-input width-percent-80"
        allowClear
        disabled={disabled}
        placeholder="Enter Mobile Number"
        {...rest}
      />
    </Space.Compact>
  );
};

export default PhoneNumberInputWithCountyCode;
